export default {
  common: {
    save: "حفظ التغييرات",
    cancel: "إلغاء",
    saving: "جاري الحفظ...",
    updating: "جاري التحديث...",
    back: "رجوع",
    error: "خطأ",
    in: "في",
    success: "تم بنجاح",
    toast: {
      success: "تم بنجاح",
      error: "خطأ",
      info: "معلومات",
      warning: "تحذير",
      copied: "تم النسخ إلى الحافظة",
      saved: "تم حفظ التغييرات",
      deleted: "تم الحذف بنجاح",
      updated: "تم التحديث بنجاح"
    }
  },
  auth: {
    signOut: "تسجيل الخروج",
    signOutSuccess: "تم تسجيل الخروج بنجاح",
    redirectingHome: "جاري إعادة التوجيه إلى الصفحة الرئيسية...",
    loginWithEmail: "تسجيل الدخول بالبريد الإلكتروني",
    createAccount: "إنشاء حساب",
    forgotPassword: "نسيت كلمة المرور",
    forgotPasswordInstructions: "الرجاء تسجيل الدخول باستخدام بريدك الإلكتروني ثم تغيير كلمة المرور",
    passwordValidation: "يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل، وحرف صغير واحد، ورقم، وحرف خاص، ويجب أن يتراوح طولها بين 8 و15 حرفًا.",
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    emailAddress: "البريد الإلكتروني",
    confirmEmailAddress: "تأكيد البريد الإلكتروني",
    termsAgreementPart1: "بإنشاء حسابك، فإنك توافق على",
    termsOfService: "شروط الخدمة",
    privacyPolicy: "سياسة الخصوصية",
    signUpToManageTrips: "سجل لبدء إدارة رحلاتك",
    enterEmailForCode: "أدخل بريدك الإلكتروني لتلقي رمز لمرة واحدة",
    verifyEmail: "التحقق من البريد الإلكتروني",
    noAccount: "ليس لديك حساب؟ سجل الآن",
    adtdTripPWaiting: "رحلتك جاهزة للاستيراد",
    adtdTripPWaitingDescription: "الرجاء تسجيل الدخول إلى حسابك، أو إنشاء حساب للمتابعة. سنتأكد من مطابقة الحجز لهويتك.",
    loginDescription: "تتبع رحلاتك الجوية، نظم رحلاتك، واحصل على جميع معلومات سفرك. كل ما تحتاجه لرحلة سلسة، في مكان واحد.",
    loginAppDescription: "كل معلومات سفرك في مكان واحد"
  },
  tripCard: {
    daysLeft: "يوم",
    flightDetails: "تفاصيل الرحلة",
    terminal: "المحطة",
    gate: "البوابة",
    checkIn: "تسجيل الدخول",
    flightInfo: "معلومات الرحلة",
    airline: "شركة الطيران",
    flight: "الرحلة",
    departure: "المغادرة",
    arrival: "الوصول",
    getFlightDetails: "تفاصيل الرحلة",
    destinationInfo: "معلومات الوجهة",
    weather: "الطقس",
    activities: "الأنشطة الموصى بها",
    food: "المطاعم والمقاهي",
    // Time related labels
    today: "اليوم",
    dayAgo: "منذ يوم واحد",
    daysAgo: "منذ {{count}} يوم",
    remainingDay: "يوم واحد متبقي",
    remainingDays: "{{count}} يوم متبقي",
    checkStatus: "التحقق من الحالة",
    tripStatus: {
      ongoing: "رحلة جارية",
      upcoming: "رحلة قادمة",
      past: "رحلة سابقة"
    },
    booking: "الحجز",
    cabinClass: "درجة المقصورة",
    bookingReference: "مرجع الحجز",
    confirmationNumbers: "أرقام التأكيد",
    // Taxi related translations
    taxiTransfer: "خدمة سيارات الأجرة",
    taxiTransferDesc: "احجز سيارة أجرة إلى الفندق أو المطار",
    taxiTransferComingSoon: "خدمة سيارات الأجرة متوفرة قريبا",
    economy: "اقتصادية",
    // Delete trip related labels
    tripDetails: "تفاصيل الرحلة",
    deleteTrip: "حذف الرحلة",
    confirmDelete: "حذف الرحلة؟",
    deleteWarning: "لا يمكن التراجع عن هذا الإجراء. سيؤدي هذا إلى حذف رحلتك إلى {{tripName}} نهائيًا وإزالتها من حسابك.",
    confirmDeleteButton: "نعم، احذف الرحلة",
    tripDeleted: "تم حذف الرحلة بنجاح.",
    deleteError: "فشل في حذف الرحلة",
    carRental: "استئجار سيارة",
    carModel: "موديل السيارة",
    pickupLocation: "موقع الاستلام",
    dropoffLocation: "موقع التسليم",
    pickup: "استلام",
    dropoff: "تسليم",
    confirmationNumber: "رقم التأكيد",
    addToCalendar: "إضافة إلى التقويم",
    notifications: "الإشعارات",
    notificationsDescription: "إشعارات مهمة حول رحلاتك",
    noNotifications: "لا توجد إشعارات حتى الآن",
    notificationsOnMobile: "هذه الميزة متاحة فقط على تطبيق الهاتف المحمول في الوقت الحالي.",
    loadingNotifications: "جارِ تحميل الإشعارات..."
  },
  settings: {
    title: "الإعدادات",
    profile: {
      title: "ملفي الشخصي",
      firstName: "الاسم الأول",
      lastName: "اسم العائلة",
      email: "البريد الإلكتروني",
      country: "البلد",
      city: "المدينة",
      selectCountry: "اختر أو اكتب اسم البلد",
      enterCity: "أدخل مدينتك"
    },
    language: {
      title: "اللغة",
      preferred: "اللغة المفضلة"
    },
    currency: {
      title: "العملة",
      preferred: "العملة المفضلة"
    },
    notifications: {
      title: "الإشعارات",
      emailNotifications: "إشعارات البريد الإلكتروني",
      description: "تلقي إشعارات البريد الإلكتروني حول التحديثات المهمة"
    },
    consent: {
      title: "إدارة الموافقة",
      open: "فتح مدير الموافقة",
      description: "إدارة تفضيلات الخصوصية وملفات تعريف الارتباط"
    },
    about: {
      title: "عنا",
      tos: "شروط الخدمة",
      privacy: "سياسة الخصوصية",
      faq: "الأسئلة الشائعة"
    },
    contact: {
      title: "اتصل بنا",
      email: "feedback@checkmytrip.com"
    },
    social: {
      title: "تابعنا على وسائل التواصل الاجتماعي"
    },
    profileUpdated: "تم تحديث الملف الشخصي بنجاح",
    updateError: "خطأ في تحديث الملف الشخصي",
    passwordMismatch: "كلمات المرور غير متطابقة",
    passwordTooShort: "يجب أن تكون كلمة المرور 8 أحرف على الأقل",
    passwordUpdated: "تم تحديث كلمة المرور بنجاح",
    changePassword: "تغيير كلمة المرور",
    newPassword: "كلمة المرور الجديدة",
    confirmPassword: "تأكيد كلمة المرور",
    updatePassword: "تحديث كلمة المرور",
    deleteAccount: "حذف الحساب",
    deleteAccountDescription: "حذف حسابك وجميع البيانات المرتبطة به بشكل دائم",
    confirmDelete: "هل أنت متأكد؟",
    deleteWarning: "لا يمكن التراجع عن هذا الإجراء. سيؤدي هذا إلى حذف حسابك نهائيًا وإزالة جميع بياناتك من خوادمنا.",
    confirmDeleteButton: "نعم، احذف حسابي",
    accountDeleted: "تم حذف حسابك بنجاح.",
    deleteError: "فشل في حذف الحساب",
    feedback: {
      title: "تعليقات",
      description: "نحن نقدر ملاحظاتك. ساعدنا على تحسين خدمتنا من خلال مشاركة أفكارك.",
      button: "تقديم التعليقات"
    }
  },
  discover: {
    title: "اكتشف التجارب",
    subtitle: "ابحث واستكشف الأنشطة لمغامرتك القادمة",
    getInspired: "احصل على الإلهام",
    searchFilters: "مرشحات البحث",
    search: "بحث",
    city: "المدينة",
    enterCityName: "أدخل اسم المدينة",
    priceRange: "نطاق السعر",
    min: "الحد الأدنى",
    max: "الحد الأقصى",
    radius: "نطاق (كم)",
    enterRadius: "أدخل النطاق",
    searchButton: "بحث",
    categoryTypes: "الفئات",
    popularActivities: "الأنشطة الشائعة",
    searchPlaceholder: "ابحث عن الأنشطة، الأماكن، أو التجارب...",
    allActivities: "جميع الأنشطة",
    inspiration: {
      location: "الموقع",
      price: "نطاق السعر",
      bestTimeToVisit: "أفضل وقت للزيارة",
      howToGetThere: "كيفية الوصول إلى هناك"
    },
    categories: {
      tour: "جولة",
      adventure: "مغامرة",
      food: "طعام وشراب",
      culture: "ثقافة",
      sightseeing: "مشاهدة المعالم",
      entertainment: "ترفيه",
      nature: "طبيعة",
      wellness: "العافية",
      sport: "رياضة",
      workshop: "ورشة عمل"
    }
  },
  newTrip: {
    title: "إضافة رحلة جديدة",
    bookingReference: "مرجع الحجز",
    bookingReferenceDesc: "أدخل مرجع الحجز المكوّن من 6 أحرف وتأكد من أن الاسم الأول واسم العائلة في ملفك الشخصي هما نفس الاسمان المستخدمان في الحجز.",
    bookingRefPlaceholder: "المرجع (مثال: ABC123)",
    bookingRefTooShort: "يجب أن يتكون مرجع الحجز من 6 أحرف على الأقل",
    bookingRefTooLong: "يمكن أن يتكون مرجع الحجز من 10 أحرف كحد أقصى",
    lastNamePlaceholder: "اسم العائلة",
    findBooking: "البحث عن الحجز",
    gmailSync: "مزامنة مع جيميل",
    gmailSyncDesc: "اسمح لنا بفحص بريدك الوارد في جيميل بحثًا عن حجوزات السفر",
    connectGmail: "ربط حساب جيميل",
    emailForward: "إعادة توجيه بريد الحجز",
    emailForwardDesc: "أعد توجيه تأكيد الحجز الخاص بك لإضافة رحلتك",
    emailCopied: "تم نسخ عنوان البريد الإلكتروني",
    emailCopiedDesc: "تم نسخ عنوان البريد الإلكتروني إلى الحافظة",
    copyEmail: "نسخ عنوان البريد الإلكتروني",
    manual: "إدخال يدوي",
    manualDesc: "أضف تفاصيل رحلتك يدويًا",
    startManual: "بدء الإدخال اليدوي",
    bookingSubmitted: "تم تقديم الحجز",
    processingBooking: "نحن نبحث عن حجزك...",
    gmailConsent: "اتصال جيميل",
    gmailProcessing: "جارٍ الاتصال بحساب جيميل الخاص بك...",
    manualEntry: "إدخال رحلة يدويًا",
    manualEntryDesc: "قم بإنشاء رحلة عن طريق إضافة تفاصيل الرحلات الجوية والفنادق بنفسك",
    drawer: {
      addTripDetails: "إضافة تفاصيل الرحلة",
      tripInfo: "معلومات الرحلة",
      tripName: "اسم الرحلة",
      tripType: "نوع الرحلة",
      selectTripType: "اختر نوع الرحلة",
      leisure: "ترفيه",
      business: "عمل",
      family: "عائلية",
      bleisure: "عمل وترفيه",
      travelers: "عدد المسافرين",
      addFlight: "إضافة رحلة طيران",
      flightNumber: "رقم الرحلة (مثال: EY1234)",
      departureDate: "تاريخ المغادرة",
      addedFlights: "الرحلات المضافة",
      from: "من:",
      to: "إلى:",
      terminal: "المحطة:",
      departure: "المغادرة:",
      arrival: "الوصول:",
      addHotel: "إضافة فندق",
      hotelName: "اسم الفندق",
      cityName: "اسم المدينة",
      selectCheckInOut: "اختر تواريخ تسجيل الدخول والخروج",
      checkIn: "تسجيل الدخول",
      checkOut: "تسجيل الخروج",
      addedHotels: "الفنادق المضافة",
      createTrip: "إنشاء رحلة",
      adding: "جارٍ الإضافة...",
      selectFlight: "اختر رحلة",
      confirmFlight: "تأكيد الرحلة",
      step1: "معلومات",
      step2: "رحلات",
      step3: "فنادق",
      step4: "مراجعة",
      next: "التالي",
      back: "رجوع",
      review: "مراجعة",
      flightsStepEmpty: "أضف رحلة طيران واحدة على الأقل إلى رحلتك",
      flightsStepWithFlights: "لقد أضفت {{count}} رحلة/رحلات",
      hotelsStepEmpty: "أضف فنادق إلى رحلتك (اختياري)",
      hotelsStepWithHotels: "لقد أضفت {{count}} فندق/فنادق",
      reviewTrip: "مراجعة رحلتك",
      reviewDescription: "تحقق من تفاصيل رحلتك قبل إنشائها",
      tripSummary: "ملخص الرحلة",
      flightsSummary: "رحلات الطيران",
      hotelsSummary: "الفنادق"
    },
    profileMismatch: "عذرًا، لا تتطابق معلومات ملفك الشخصي مع الحجز. يرجى الانتقال إلى الملف الشخصي والتأكد من أن اسمك الأول واسم العائلة هما نفس الاسمين المستخدمين لإجراء الحجز. يمكنك أيضًا محاولة استيراد رحلتك باستخدام الخيارات التالية أدناه عن طريق إعادة توجيه بريد تأكيد الحجز أو إدخال الرحلة يدويًا."
  },
  index: {
    greeting: "مرحباً، مسافر",
    greetingWithName: "مرحباً، {{name}}",
    manageTrips: "إدارة رحلاتك",
    bookingRef: "مرجع الحجز",
    lastName: "اسم العائلة",
    addTrip: "إضافة رحلة",
    timeline: "الجدول الزمني الخاص بك",
    travelPlans: "خطط سفرك",
    errorFetchingTrips: "تأكد من أنك متصل بحساب يحمل الاسم والبريد الإلكتروني المطابقين.",
    viewUpcomingFlights: "عرض الرحلات القادمة",
    importAdtdTripSuccess: "تم استيراد الرحلة بنجاح",
    importAdtdTripError: "خطأ في استيراد الرحلة",
    checkYourTrips: "تحقق من رحلاتك في التطبيق",
    welcome: {
      title: "مرحباً بك في رحلة سفرك!",
      features: {
        tripManagement: {
          title: "إدارة الرحلات",
          description: "احتفظ بجميع تفاصيل سفرك في مكان واحد - الرحلات الجوية والفنادق والأنشطة."
        },
        tripAlerts: {
          title: "تنبيهات الرحلة",
          description: "تلقي إشعارات فورية حول رحلاتك الجوية وتغييرات البوابة وتحديثات السفر المهمة."
        },
        offers: {
          title: "عروض مخصصة",
          description: "احصل على عروض سفر مخصصة بناءً على تفضيلاتك ورحلاتك السابقة."
        },
        inspiration: {
          title: "إلهام السفر",
          description: "اكتشف وجهات جديدة واحصل على توصيات مخصصة لمغامراتك"
        }
      },
      tips: {
        profile: "أكمل ملفك الشخصي للحصول على توصيات مخصصة",
        addTrip: "انقر على زر + لإضافة رحلتك الأولى",
        notifications: "قم بتمكين الإشعارات لعدم تفويت تحديثات السفر المهمة",
        dates: "تتبع تواريخ السفر المهمة في تقويمك"
      },
      getStarted: "نصائح سريعة للبدء",
      ready: "هل أنت مستعد لبدء رحلتك؟ دعنا نجعل كل رحلة لا تُنسى! ✈️"
    }
  },
  weather: {
    in: "Weather in",
    loading: "Loading weather data...",
    currentWeather: "Current Weather",
    forecast: "Forecast",
    temperature: "Temperature",
    feelsLike: "Feels like",
    wind: "Wind",
    humidity: "Humidity",
    precipitation: "Precipitation",
    pressure: "Pressure",
    visibility: "Visibility",
    uvIndex: "UV Index",
    sunrise: "Sunrise",
    sunset: "Sunset",
    daily: "Daily",
    hourly: "Hourly",
    today: "Today",
    tomorrow: "Tomorrow",
    min: "Min",
    max: "Max"
  },
  sidebar: {
    myTrips: "رحلاتي",
    discover: "استكشاف",
    newTrip: "رحلة جديدة",
    profile: "الملف الشخصي",
    feedback: "تعليقات"
  },
  errors: {
    configurationError: "خطأ في التكوين",
    websiteNotConfigured: "لم يتم تكوين الموقع بشكل صحيح."
  }
}
